import React, { useEffect, useState } from "react";

import useAPI from "services/Api";
import { isLoggedIn } from "services/AccountServices";
import { useCindraEnabled } from "cindra/CindraUtils";

const StickyFooter = ({ parentComponentName = null, internal }) => {
    const componentName = `${parentComponentName || ""}[StickyFooter]`;
    const buildVersion = import.meta.env.VITE_BUILD_VERSION;
    const buildEnvironment = import.meta.env.VITE_BUILD_ENVIRONMENT;
    const cindraEnabled = useCindraEnabled();
    const cindraStatusUrl = import.meta.env.VITE_CINDRA_STATUS_URL;
    const API = useAPI();

    /** State **/

    const [apiVersion, setApiVersion] = useState(null);
    const [agentVersion, setAgentVersion] = useState(null);

    // ---=== Utilities ===--- //

    const onApiVersionSuccess = (version) => {
        setApiVersion(version);
    };

    const fetchAgentVersion = async () => {
        if (!cindraEnabled) {
            return;
        }

        if (!cindraStatusUrl) {
            console.warn(`${componentName} VITE_CINDRA_STATUS_URL is not configured`);
            return;
        }

        try {
            const response = await fetch(`${cindraStatusUrl}/version`);
            if (response.ok) {
                const data = await response.json();
                setAgentVersion(data.version);
            } else {
                console.warn(`${componentName} Failed to fetch agent version: ${response.status}`);
            }
        } catch (error) {
            console.warn(`${componentName} Error fetching agent version:`, error);
        }
    };

    // ---=== useEffects ===--- //

    useEffect(
        () => {
            if (isLoggedIn()) {
                void API.api_Version(componentName, onApiVersionSuccess);
            }

            // Fetch agent version only if Cindra is enabled
            if (cindraEnabled) {
                void fetchAgentVersion();
            }
        }, []
    );

    // ---=== Render ===--- //

    return (
        <React.Fragment>
            <footer className={internal ? "whitespace-nowrap overflow-hidden bg-brand-100 relative inset-x-0 p-2 justify-start items-center inline-flex w-full" : "whitespace-nowrap overflow-hidden bg-brand-100 absolute inset-x-0 bottom-0 p-2 justify-center items-center inline-flex"}>
                <div className="px-2 text-gray-500 text-xs font-normal leading-none">© Karuna Labs 2025</div>
                <div className="px-2 grow basis-0 text-right text-gray-500 text-xs font-normal leading-none">
                    <span>{`${buildEnvironment && buildEnvironment !== "Production" ? `Portal:` : ""}${buildVersion ? ` ${buildVersion}` : ""}`}</span>
                    {cindraEnabled && <span className="ml-2">{agentVersion ? `Cindra: ${agentVersion}` : "Cindra: [Unavailable]"}</span>}
                    <span className="ml-2">{apiVersion ? `Api: ${apiVersion}` : ""}</span>
                </div>
            </footer>
        </React.Fragment>
    );
};

export default StickyFooter;
